import React from "react";
import { Loader2, MinusIcon, PlusIcon } from "lucide-react";
import { apiCall } from "../../../src/lib/api";
import { useCookies } from "react-cookie";
import { useQueryClient } from "react-query";
import { Button } from "../../../src/components/ui/button";
export default function UpdateProductQuatity({
  productId,
  quantity,
}: {
  productId: string;
  quantity: string;
}) {
  const reactQuery = useQueryClient();
  const [cookies] = useCookies(["cartKey", "userToken"]);
  const [loading, setLoading] = React.useState(false);
  async function updateProductQuantity(
    id: string,
    quantity: string
  ) {
    const qty = Number(quantity);
    if (qty < 1) return;
    setLoading(true);
    try {
      const key = localStorage.getItem("cart_key");
      const url = `${apiCall}/wp-json/cocart/v2/cart/item/${id}${
        key === null ? "" : `?cart_key=${key}`
      }`;

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(cookies.userToken && {
            Authorization: `Bearer ${cookies.userToken}`,
          }),
        },
        body: JSON.stringify({ quantity: quantity }),
      });

      if (!res.ok) {
        setLoading(false);
        throw new Error(`HTTP error: ${res.status}`);
      }

      const response = await res.json();
      reactQuery.refetchQueries(["cartItems"]);
      setLoading(false);
      return response;
    } catch (error) {
      setLoading(false);
      console.error(
        "Error updating product quantity:",
        error
      );
    }
  }

  return (
    <div className="border flex gap-1 justify-center items-center w-fit">
      <Button
        variant="ghost"
        disabled={loading}
        className="rounded-none w-12"
        onClick={() =>
          updateProductQuantity(
            productId,
            String(Number(quantity) - 1)
          )
        }
      >
        <MinusIcon className="size-12" />
      </Button>
      {loading ? (
        <Loader2 className="size-4 animate-spin duration-700" />
      ) : (
        <p className="text-sm w-6 text-center">
          {quantity}
        </p>
      )}

      <Button
        variant="ghost"
        disabled={loading}
        className="rounded-none w-12"
        onClick={() =>
          updateProductQuantity(
            productId,
            String(Number(quantity) + 1)
          )
        }
      >
        <PlusIcon className="size-6" />
      </Button>
    </div>
  );
}
